<script>
  export default {
    props: {
      color: {
        type: String,
        required: false,
        default: "var(--neutral-500)",
      },
    },
  };
</script>
<template>
  <svg
    width="20" height="21"
    viewBox="0 0 20 21" fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3081 5.39167C12.4995 5.50031 12.726 5.52886 12.9383 5.4711C13.1507 5.41334 13.3315 5.27394 13.4415
5.08333C13.5324 4.9228 13.6741 4.79699 13.8443 4.72565C14.0144 4.65431 14.2035 4.64146 14.3817 4.68912C14.56
4.73678 14.7174 4.84226 14.8292 4.98901C14.9411 5.13576 15.0011 5.31549 14.9998 5.5C14.9998 5.72101 14.912
5.93297 14.7557 6.08926C14.5994 6.24554 14.3875 6.33333 14.1665 6.33333C13.9454 6.33333 13.7335 6.42113 13.5772
6.57741C13.4209 6.73369 13.3331 6.94565 13.3331 7.16667C13.3331 7.38768 13.4209 7.59964 13.5772 7.75592C13.7335
7.9122 13.9454 8 14.1665 8C14.6052 7.99972 15.0362 7.88396 15.4161 7.66436C15.7959 7.44476 16.1113 7.12905 16.3305
6.74896C16.5497 6.36886 16.665 5.93777 16.6649 5.499C16.6647 5.06022 16.549 4.62922 16.3295 4.24931C16.11 3.86939
15.7944 3.55393 15.4143 3.33464C15.0343 3.11534 14.6032 2.99993 14.1645 3C13.7257 3.00007 13.2947 3.11562 12.9147
3.33504C12.5347 3.55445 12.2192 3.87001 11.9998 4.25C11.9447 4.34511 11.909 4.45018 11.8946 4.55917C11.8803
4.66815 11.8877 4.77889 11.9164 4.885C11.945 4.99112 11.9944 5.09052 12.0616 5.17747C12.1289 5.26443 12.2126
5.33722 12.3081 5.39167ZM15.8915 11.3333C15.6727 11.3049 15.4516 11.3644 15.2767 11.4988C15.1017 11.6331 14.9872
11.8313 14.9581 12.05C14.7832 13.4626 14.0979 14.7626 13.0311 15.705C11.9644 16.6474 10.5899 17.1673 9.16646
17.1667H4.50812L5.04979 16.625C5.205 16.4689 5.29212 16.2577 5.29212 16.0375C5.29212 15.8173 5.205 15.6061
5.04979 15.45C4.23725 14.6343 3.68428 13.5963 3.46053 12.4669C3.23679 11.3375 3.35228 10.1671 3.79246
9.10319C4.23263 8.03928 4.97781 7.12943 5.93411 6.48824C6.89042 5.84705 8.01509 5.5032 9.16646 5.5C9.38747
5.5 9.59943 5.4122 9.75571 5.25592C9.91199 5.09964 9.99979 4.88768 9.99979 4.66667C9.99979 4.44565 9.91199
4.23369 9.75571 4.07741C9.59943 3.92113 9.38747 3.83333 9.16646 3.83333C7.75748 3.83921 6.37866 4.24186 5.18795
4.99516C3.99725 5.74846 3.04282 6.82193 2.43401 8.0926C1.8252 9.36327 1.58664 10.7797 1.74566 12.1797C1.90468
13.5797 2.45484 14.9066 3.33312 16.0083L1.90812 17.4083C1.79249 17.5255 1.71416 17.6743 1.68302 17.836C1.65187
17.9976 1.66931 18.1649 1.73312 18.3167C1.79564 18.4688 1.90181 18.5991 2.03824 18.6911C2.17467 18.783 2.33527
18.8325 2.49979 18.8333H9.16646C10.9927 18.8336 12.7562 18.1675 14.1263 16.9601C15.4964 15.7526 16.3788 14.0868
16.6081 12.275C16.6234 12.166 16.6169 12.0552 16.589 11.9487C16.5612 11.8423 16.5126 11.7424 16.446
11.6549C16.3793 11.5673 16.296 11.4938 16.2009 11.4387C16.1057 11.3835 16.0005 11.3477 15.8915 11.3333ZM14.4831
8.89167C14.3314 8.82454 14.1631 8.80423 13.9998 8.83333L13.8498 8.88333L13.6998 8.95833L13.5748 9.06667C13.4998
9.14346 13.4404 9.23401 13.3998 9.33333C13.3505 9.43728 13.3276 9.55177 13.3331 9.66667C13.3307 9.77781 13.3505
9.88831 13.3915 9.99167C13.4346 10.0917 13.4968 10.1823 13.5748 10.2583C13.6527 10.3356 13.745 10.3967 13.8465
10.4381C13.9481 10.4796 14.0568 10.5006 14.1665 10.5C14.3875 10.5 14.5994 10.4122 14.7557 10.2559C14.912 10.0996
14.9998 9.88768 14.9998 9.66667C15.0026 9.55735 14.9798 9.4489 14.9331 9.35C14.8436 9.14976 14.6834 8.98954 14.4831
8.9V8.89167Z" :fill="color"
    />
  </svg>
</template>

<style>

</style>
